(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["noscrub-paired-products"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-noscrub-gallery]').forEach((gallery) => {
    if (gallery.dataset.initialized === 'true') return;
    gallery.dataset.initialized = 'true';

    const track = gallery.querySelector('[data-noscrub-gallery-track]');
    const progressTrack = gallery.querySelector('[data-noscrub-gallery-progress-track]');
    const progress = gallery.querySelector('[data-noscrub-gallery-progress]');
    const previous = gallery.querySelector('[data-noscrub-gallery-previous]');
    const next = gallery.querySelector('[data-noscrub-gallery-next]');
    let frame;

    const update = () => {
      if (!progressTrack || !progress) return;

      const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      const availableTravel = Math.max(0, progressTrack.clientWidth - progress.clientWidth);
      const scrollRatio = maxScroll > 0 ? Math.min(1, Math.max(0, track.scrollLeft / maxScroll)) : 0;

      progress.style.transform = `translate3d(${availableTravel * scrollRatio}px, 0, 0)`;
    };

    const move = (direction) => {
      track.scrollBy({ left: track.clientWidth * direction, behavior: 'smooth' });
    };

    previous?.addEventListener('click', () => move(-1));
    next?.addEventListener('click', () => move(1));
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(update);
    }, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  });

  } catch(e) { console.error(e); }
})();
})();
